import { render, staticRenderFns } from "./PercentageBadge.vue?vue&type=template&id=182469b0"
import script from "./PercentageBadge.vue?vue&type=script&lang=js"
export * from "./PercentageBadge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports